import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />

      <div className="pt-20 pb-4 bg-white border-b border-stone-100">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <nav className="flex items-center gap-2 text-sm text-stone-500">
            <Link to="/" className="hover:text-stone-900 transition-colors cursor-pointer">{t('breadcrumb_home')}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-stone-900 font-medium">{t('breadcrumb_about')}</span>
          </nav>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl border border-stone-200 p-6 md:p-10 shadow-sm">
            <h1 className="text-2xl md:text-3xl font-bold text-stone-900 mb-6">{t('about_title')}</h1>
            <p className="text-stone-600 leading-relaxed mb-8">{t('about_desc')}</p>

            <div className="space-y-8">
              <div>
                <h2 className="text-lg font-bold text-stone-900 mb-3">{t('about_mission')}</h2>
                <p className="text-stone-600 leading-relaxed">{t('about_mission_desc')}</p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-stone-900 mb-3">{t('about_vision')}</h2>
                <p className="text-stone-600 leading-relaxed">{t('about_vision_desc')}</p>
              </div>

              <div>
                <h2 className="text-lg font-bold text-stone-900 mb-3">{t('about_values')}</h2>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-stone-600">
                    <i className="ri-check-line text-emerald-500 mt-1"></i>
                    {t('about_values_transparency')}
                  </li>
                  <li className="flex items-start gap-2 text-stone-600">
                    <i className="ri-check-line text-emerald-500 mt-1"></i>
                    {t('about_values_accuracy')}
                  </li>
                  <li className="flex items-start gap-2 text-stone-600">
                    <i className="ri-check-line text-emerald-500 mt-1"></i>
                    {t('about_values_independence')}
                  </li>
                  <li className="flex items-start gap-2 text-stone-600">
                    <i className="ri-check-line text-emerald-500 mt-1"></i>
                    {t('about_values_helpfulness')}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}